import { type App, } from 'vue';
import { vDebouncedClick, } from './vDebouncedClick';
import { vClickOutside, vClickOutsideName, } from './vClickOutside';
import { vTrackExpose, vTrackExposeName, } from './vTrackExpose';

function setupDirectives(app: App) {
  app.directive('v-debounded-click', vDebouncedClick);
  app.directive(vClickOutsideName, vClickOutside);
  app.directive(vTrackExposeName, vTrackExpose);
}

export default setupDirectives;

export { setupDirectives, };
